<template>
  <component
    :is="comp.name"
    v-if="vif"
    v-bind="props"
    v-dynamic-events="events"
    v-model="vmodel"
    :relatedVmodel="relatedVmodel"
    :theProps="props"
  >
    <div v-if="comp.content">{{ comp.content }}</div>
    <dynamic-component
      v-for="(child, index2) in children"
      :key="'component_'+id+'_'+index2"
      :comp="child"
      :stepValues="stepValues"
      :relatedStepValues="relatedStepValues"
      v-dynamic-events="events"
    />
  </component>
</template>

<script>
import dynamicEvents from "../mixins/dynamicEvents";
import BooleanInput from "../components/form/BooleanInput";
import BooleanInputTable from "../components/form/BooleanInputTable";
import RadioButtons from "../components/form/RadioButtons";
import Textfield from "../components/simple/Textfield";
import TextAreaField from "../components/simple/TextAreaField";
import DatePicker from "../components/simple/DatePicker";
import ImageUploadBox from "../components/upload/ImageUploadBox"
import PartSliderHolder from "../components/partSlider/PartSliderHolder"
import InsuranceList from "../components/insuranceList/InsuranceList"
export default {
  props: ["comp", "stepValues", "relatedStepValues"],
  name: "dynamic-component",
  mixins: [dynamicEvents],
  components: {
    BooleanInput,
    BooleanInputTable,
    RadioButtons,
    Textfield,
    TextAreaField,
    DatePicker,
    ImageUploadBox,
    PartSliderHolder,
    InsuranceList
  },
  data() {
    return {
      vmodel: null,
      relatedVmodel: null,
      id: null
    };
  },
  mounted() {
    if (this.comp.vmodel != undefined && this.comp.vmodel != null) {
      this.vmodel = eval(this.comp.vmodel)
      try {
        this.relatedVmodel = eval(this.comp.vmodel.replace("stepValues", "relatedStepValues"))
      } catch (e) {
        if (e instanceof SyntaxError) {
          console.log("Could not find related vmodel")
        }
      }
    }
    this.id = this._uid;
  },
  computed: {
    vif: function() {
      if (this.comp.if != undefined && this.comp.if != null) {
        return eval(this.comp.if);
      }
      if (this.comp.vmodel != undefined && this.comp.vmodel != null) {
        if(this.vmodel) {
          return true;
        }
        return false
      }
      return true
    },
    children: function() {
      if (this.comp.children != undefined && this.comp.children != null) {
        return this.comp.children;
      }
      return [];
    },
    events: function() {
      /*
      if(this.comp.events != undefined && this.comp.events != null) {
        return this.comp.events
      }*/
      return ["save-state", "update-fields", "previous-page", "next-page"];
    },
    props: function() {
      if (this.comp.props != undefined && this.comp.props != null) {
        return this.comp.props;
      }
      return [];
    }
  }
};
</script>